// The app claims the bare domain as well as www, so a link there counts as leaving the site.
const IOS_UNIVERSAL_LINK_HOST = 'bokadirekt.se';

export const SMART_LINKS = Object.freeze({
  BASE_URL: 'https://www.bokadirekt.se/app?link=',
  HOME: 'https://www.bokadirekt.se/app',
  CONFIRMED: 'https://www.bokadirekt.se/app?link=https://www.bokadirekt.se/bokningar',
  BOOKINGS: 'https://www.bokadirekt.se/app?link=https://www.bokadirekt.se/bokningar',
  BOOKINGS_FINISHED: 'https://www.bokadirekt.se/app?link=https://www.bokadirekt.se/bokningar/tidigare',
  FAVORITES: 'https://www.bokadirekt.se/app?link=https://www.bokadirekt.se/favoriter',
  getPlaceSmartLink: (placeUrl: string) => `${SMART_LINKS.BASE_URL}${placeUrl}`,
  getSerpSmartLink: (serpUrl: string) => `${SMART_LINKS.BASE_URL}${serpUrl}`,
  getShareSmartLink: (placeId: number, serviceIds: number[], employeeId?: number) => {
    const ids = (serviceIds || []).filter(Boolean);
    if (!placeId || !ids.length) return SMART_LINKS.HOME;

    const employeePath = employeeId ? `/${employeeId}` : '';
    return `${SMART_LINKS.BASE_URL}https://www.bokadirekt.se/share/${placeId}/${ids.join('-')}${employeePath}`;
  },
  forceRedirectToStore: (downloadAppUrl: string) => {
    try {
      const _downloadAppUrl = new URL(downloadAppUrl);
      _downloadAppUrl.searchParams.append('go', '1');
      return _downloadAppUrl.toString();
    } catch (e) {
      return SMART_LINKS.HOME;
    }
  },
  /**
   * Safari ignores universal links to the domain the visitor is already on, so link to the bare
   * domain instead. With the app installed, iOS opens it; without, Safari loads the page, which
   * redirects to www and on to the App Store. A custom-scheme link can't do this: Safari shows an
   * "invalid address" error when no app is there to open it.
   */
  openIOSAppOrStore: (smartLink: string) => {
    const storeUrl = new URL(SMART_LINKS.forceRedirectToStore(smartLink));
    storeUrl.hostname = IOS_UNIVERSAL_LINK_HOST;
    window.location.href = storeUrl.toString();
  },
});
